import { CommonMap } from 'client/tracking/maps/common';
import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';

const map = {
  close_checkmark_x: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.CLOSE_CHECKMARK_X),
  close_checkmark: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.CLOSE_CHECKMARK),
  save_model: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.SAVE_MODEL),
  unsave_model: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.UNSAVE_MODEL),
  close_confirmation_x: TrackingEvent.actionCompleted(
    TrackingConstant.SAVE_VEHICLE,
    TrackingConstant.CLOSE_CONFIRMATION_X
  ),
  close_confirmation: TrackingEvent.actionCompleted(TrackingConstant.SAVE_VEHICLE, TrackingConstant.CLOSE_CONFIRMATION),
  view_saved_models: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_SAVED_MODELS
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};
